var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-img',{staticClass:"virtual-assistant-avatar",attrs:{"src":"https://eyeinlivestorage.blob.core.windows.net/public/eye-intelligence/virtual-assistant/virtual-assistant.png"}})
}
var staticRenderFns = []

export { render, staticRenderFns }